// extracted by mini-css-extract-plugin
export default {"container":"PasswordStrength_container__vozka","backgroundBar":"PasswordStrength_backgroundBar__0Rzt6","bar":"PasswordStrength_bar__S0jAW","word":"PasswordStrength_word__+90Ov"};